define(['jquery', 'magnificPopup'], function($) {
    "use strict";
    return {
        init: function (selector) {
            var self = this;
            $(selector).each(function () {
                $(this).magnificPopup({
                    delegate: 'a.lightbox',
                    tClose: 'Schließen (Esc)',
                    type: 'image',
                    tLoading: 'Lade Bild #%curr%...',
                    mainClass: 'mfp-img-mobile',
                    gallery: {
                        enabled: 1,
                        preload: [1, 2],
                        navigateByImgClick: 1,
                        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                        tPrev: 'Vorheriges (Linke Pfeiltaste)',
                        tNext: 'Nächstes (Rechte Pfeiltaste)',
                        tCounter: '%curr% von %total%'
                    },
                    image: {
                        cursor: 'mfp-zoom-out-cur',
                        titleSrc: function(item) {
                            var $imageWrap = item.el.parents('figure').first();
                            var $caption = null;
                            if ($imageWrap) {
                                $caption = $imageWrap.find('figcaption');
                            }
                            var captionText = $caption.length > 0 ? $caption.text() : item.el.attr('title');
                            if (!captionText) {
                                captionText = ' ';
                            }
                            return captionText;
                        },
                        verticalGap: 88,
                        verticalFit: 1,
                        tError: '<a href="%url%">Das Bild</a> konnte nicht geladen werden.'
                    },
                    removalDelay: 0
                });
            });
        },
        initImageSourceBox: function() {
            $('#menu-footer li:last-child a').magnificPopup({
                items: {
                    src: '#image-sources',
                    type: 'inline'
                }
            });
        },
        setTitle: function (item) {
            var $imageWrap = item.el.parents('.csc-textpic-image').first();
            var $caption = null;
            if ($imageWrap) {
                $caption = $(item).parent().find('figcaption');
                if (!$caption.length) {
                    $caption = $imageWrap.find('.csc-textpic-caption');
                }
            }
            if (!$caption.length) {
                $caption = item.el.next('.news-single-imgcaption');
            }
            var captionText = $caption.length > 0 ? $caption.text() : item.el.attr('title');
            if (!captionText) {
                captionText = ' ';
            }
            return captionText;
        }
    };
});